// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../node_modules/ui-connect/styles/variables.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConnectionList_itemContainer__poWfA {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    transition: opacity 1s, transform 1s ease 1s;
}

/* copy styles from ui-connect Card component */
.ConnectionList_itemContainer__poWfA.ConnectionList_card__9iXQa {
    background-color: var(--color-white);
    border: 1px solid var(--color-lightui-surface-4);
    border-radius: 4px;
    margin: 15px 0;
}
.ConnectionList_itemContainer__poWfA.ConnectionList_card__9iXQa.ConnectionList_dismissing__bHyDr {
    border: none;
}

.ConnectionList_userWrapper__b53Qb {
    display: flex;
    width: 100%;
    padding: 8px 15px;
}
.ConnectionList_userWrapper__b53Qb:hover {
    padding: 7px 14px; /* decrease 1px on each direction for border 1px */
    border: 1px solid var(--color-darkui-surface-2);
    border-radius: 6px;
}
.ConnectionList_card__9iXQa .ConnectionList_userWrapper__b53Qb:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border: none;
    border-radius: 0;
    padding: 8px 15px;
}
.ConnectionList_card__9iXQa.ConnectionList_dismissing__bHyDr {
    box-shadow: none;
}

.ConnectionList_nameWrapper__YHgv- {
    max-width: calc(100% - 130px); /* reserve 130px for connect button and dismiss button */
    color: black; /* To override the gray color set for ".widget-footer a" selector which is applied to Activity Widget */
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.ConnectionList_fullWidth__I-vea {
    max-width: 100%;
}

.ConnectionList_avatarWrapper__wZkKe {
    flex-shrink: 0; /* prevent it from being squashed */
    margin-right: 24px;
    position: relative;
    height: 48px; /* same height as avatar to make sure badge level icon staying at correct position */
}
.ConnectionList_avatarWrapper__wZkKe div[class^='badge-level'] {
    position: absolute;
    bottom: 0;
    right: 0;
}
.ConnectionList_avatar__COuHB {
    aspect-ratio: 1;
    width: 48px;
    object-fit: cover;
    clip-path: circle(50%);
}
.ConnectionList_avatar__COuHB[data-noclip='true'],
.ConnectionList_avatar__COuHB[src\$='-pmpr.png'],
.ConnectionList_avatar__COuHB[src\$='-pmfr.png'],
.ConnectionList_avatar__COuHB[src\$='-pmth.png'] {
    clip-path: none;
}

.ConnectionList_userInfoContainer__rc\\+CB {
    min-height: 48px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: normal; /* To override the 44px set for ".wighet-footer" selector which is applied to Activity Widget */
}
.ConnectionList_userName__fjt1I {
    font-size: 14px;
    font-weight: 700;
    word-break: break-word;
}

a.ConnectionList_userWrapper__b53Qb:hover .ConnectionList_userName__fjt1I {
    text-decoration: underline;
}
a.ConnectionList_userWrapper__b53Qb:hover {
    text-decoration: none; /* This is for overriding a:hover underline effect, to prevent from adding underline to .textConnectionDescription
                              when not hovering on it */
}

.ConnectionList_textConnectionDescription__pyXq2 {
    font-size: 12px;
    color: var(--color-darkui-accent-2);
    width: fit-content;
    max-width: calc(100% - 130px); /* reserve 130px for connect button and dismiss button */
    text-decoration: none;
}
.ConnectionList_textConnectionDescription__pyXq2.ConnectionList_clickable__d6LzL:hover {
    text-decoration: underline;
    cursor: pointer;
}

.ConnectionList_animated__4ZsdO {
    animation-duration: 0.5s;
    animation-name: ConnectionList_slideUp__nRwh1;
}

@keyframes ConnectionList_slideUp__nRwh1 {
    from {
        transform: translateY(100%);
    }
    to {
        transform: none;
    }
}

.ConnectionList_dismissingOverlay__KoEt6 {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--color-white);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 8px 15px;
    transition: opacity 1s;
}
.ConnectionList_dismissingOverlay__KoEt6:hover {
    padding: 7px 14px;
}

/* For card style, we don't need to adjust padding on hover */
.ConnectionList_itemContainer__poWfA.ConnectionList_card__9iXQa .ConnectionList_dismissingOverlay__KoEt6:hover {
    padding: 8px 15px;
}

.ConnectionList_show__Qo3rf {
    opacity: 1;
}
.ConnectionList_hide__fTj9D {
    opacity: 0;
    visibility: hidden;
}

.ConnectionList_actionWrapper__L1Wyt {
    position: absolute;
    right: 0;
    margin-right: 15px; /* align left padding of userWrapper */
    display: flex; /* For the action button to align center, mainly set for Activity Widget */
}

.ConnectionList_loaderContainer__exu-c {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 8px 15px 16px;
    box-sizing: border-box;
}

.ConnectionList_barWrapper__8DiQr {
    width: calc(100% - 72px);
    height: 48px;
}

.ConnectionList_spinner__CwQDd {
    text-align: center;
    height: 60px;
}

.ConnectionList_groupRoleLabel__n-8VM {
    font-size: 12px;
    font-weight: 400;
    line-height: 21px;
    background-color: var(--color-lightui-accent-1);
    border-radius: 4px;
    padding: 0px 8px;
    margin-left: 4px;
}

@media (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["endXS"]}) {
    .ConnectionList_userInfoContainer__rc\\+CB {
        gap: 8px;
    }

    .ConnectionList_userName__fjt1I,
    .ConnectionList_textConnectionDescription__pyXq2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical; /* Need to add comment below to prevent this attribute from being removed */
        /* autoprefixer: off */
        word-break: break-word; /* For long name with no space to break into multiple lines */
        overflow: hidden;
        max-width: 100%;
    }

    .ConnectionList_actionWrapper__L1Wyt {
        position: relative;
        display: flex; /* For the action button to align center, mainly set for Activity Widget */
        /* margin-top: 8px; */
        margin-right: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ConnectionList/ConnectionList.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA,+CAA+C;AAC/C;IACI,oCAAoC;IACpC,gDAAgD;IAChD,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,iBAAiB,EAAE,kDAAkD;IACrE,+CAA+C;IAC/C,kBAAkB;AACtB;AACA;IACI,yCAAyC;IACzC,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B,EAAE,wDAAwD;IACvF,YAAY,EAAE,uGAAuG;IACrH,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc,EAAE,mCAAmC;IACnD,kBAAkB;IAClB,kBAAkB;IAClB,YAAY,EAAE,oFAAoF;AACtG;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;;;;IAII,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB,EAAE,+FAA+F;AACxH;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,qBAAqB,EAAE;uDAC4B;AACvD;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,6BAA6B,EAAE,wDAAwD;IACvF,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,6CAAuB;AAC3B;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;;AAEA,6DAA6D;AAC7D;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,kBAAkB,EAAE,sCAAsC;IAC1D,aAAa,EAAE,0EAA0E;AAC7F;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;;QAEI,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B,EAAE,2EAA2E;QACzG,sBAAsB;QACtB,sBAAsB,EAAE,6DAA6D;QACrF,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,aAAa,EAAE,0EAA0E;QACzF,qBAAqB;QACrB,eAAe;IACnB;AACJ","sourcesContent":["@value (endXS) from 'ui-connect/styles/variables.module.css';\n\n.itemContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    transition: opacity 1s, transform 1s ease 1s;\n}\n\n/* copy styles from ui-connect Card component */\n.itemContainer.card {\n    background-color: var(--color-white);\n    border: 1px solid var(--color-lightui-surface-4);\n    border-radius: 4px;\n    margin: 15px 0;\n}\n.itemContainer.card.dismissing {\n    border: none;\n}\n\n.userWrapper {\n    display: flex;\n    width: 100%;\n    padding: 8px 15px;\n}\n.userWrapper:hover {\n    padding: 7px 14px; /* decrease 1px on each direction for border 1px */\n    border: 1px solid var(--color-darkui-surface-2);\n    border-radius: 6px;\n}\n.card .userWrapper:hover {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    border: none;\n    border-radius: 0;\n    padding: 8px 15px;\n}\n.card.dismissing {\n    box-shadow: none;\n}\n\n.nameWrapper {\n    max-width: calc(100% - 130px); /* reserve 130px for connect button and dismiss button */\n    color: black; /* To override the gray color set for \".widget-footer a\" selector which is applied to Activity Widget */\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.fullWidth {\n    max-width: 100%;\n}\n\n.avatarWrapper {\n    flex-shrink: 0; /* prevent it from being squashed */\n    margin-right: 24px;\n    position: relative;\n    height: 48px; /* same height as avatar to make sure badge level icon staying at correct position */\n}\n.avatarWrapper div[class^='badge-level'] {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n.avatar {\n    aspect-ratio: 1;\n    width: 48px;\n    object-fit: cover;\n    clip-path: circle(50%);\n}\n.avatar[data-noclip='true'],\n.avatar[src$='-pmpr.png'],\n.avatar[src$='-pmfr.png'],\n.avatar[src$='-pmth.png'] {\n    clip-path: none;\n}\n\n.userInfoContainer {\n    min-height: 48px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    line-height: normal; /* To override the 44px set for \".wighet-footer\" selector which is applied to Activity Widget */\n}\n.userName {\n    font-size: 14px;\n    font-weight: 700;\n    word-break: break-word;\n}\n\na.userWrapper:hover .userName {\n    text-decoration: underline;\n}\na.userWrapper:hover {\n    text-decoration: none; /* This is for overriding a:hover underline effect, to prevent from adding underline to .textConnectionDescription\n                              when not hovering on it */\n}\n\n.textConnectionDescription {\n    font-size: 12px;\n    color: var(--color-darkui-accent-2);\n    width: fit-content;\n    max-width: calc(100% - 130px); /* reserve 130px for connect button and dismiss button */\n    text-decoration: none;\n}\n.textConnectionDescription.clickable:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.animated {\n    animation-duration: 0.5s;\n    animation-name: slideUp;\n}\n\n@keyframes slideUp {\n    from {\n        transform: translateY(100%);\n    }\n    to {\n        transform: none;\n    }\n}\n\n.dismissingOverlay {\n    position: absolute;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--color-white);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 4px;\n    box-sizing: border-box;\n    padding: 8px 15px;\n    transition: opacity 1s;\n}\n.dismissingOverlay:hover {\n    padding: 7px 14px;\n}\n\n/* For card style, we don't need to adjust padding on hover */\n.itemContainer.card .dismissingOverlay:hover {\n    padding: 8px 15px;\n}\n\n.show {\n    opacity: 1;\n}\n.hide {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.actionWrapper {\n    position: absolute;\n    right: 0;\n    margin-right: 15px; /* align left padding of userWrapper */\n    display: flex; /* For the action button to align center, mainly set for Activity Widget */\n}\n\n.loaderContainer {\n    width: 100%;\n    height: 60px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 8px 15px 16px;\n    box-sizing: border-box;\n}\n\n.barWrapper {\n    width: calc(100% - 72px);\n    height: 48px;\n}\n\n.spinner {\n    text-align: center;\n    height: 60px;\n}\n\n.groupRoleLabel {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 21px;\n    background-color: var(--color-lightui-accent-1);\n    border-radius: 4px;\n    padding: 0px 8px;\n    margin-left: 4px;\n}\n\n@media (max-width: endXS) {\n    .userInfoContainer {\n        gap: 8px;\n    }\n\n    .userName,\n    .textConnectionDescription {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical; /* Need to add comment below to prevent this attribute from being removed */\n        /* autoprefixer: off */\n        word-break: break-word; /* For long name with no space to break into multiple lines */\n        overflow: hidden;\n        max-width: 100%;\n    }\n\n    .actionWrapper {\n        position: relative;\n        display: flex; /* For the action button to align center, mainly set for Activity Widget */\n        /* margin-top: 8px; */\n        margin-right: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"endXS": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["endXS"]}`,
	"itemContainer": `ConnectionList_itemContainer__poWfA`,
	"card": `ConnectionList_card__9iXQa`,
	"dismissing": `ConnectionList_dismissing__bHyDr`,
	"userWrapper": `ConnectionList_userWrapper__b53Qb`,
	"nameWrapper": `ConnectionList_nameWrapper__YHgv-`,
	"fullWidth": `ConnectionList_fullWidth__I-vea`,
	"avatarWrapper": `ConnectionList_avatarWrapper__wZkKe`,
	"avatar": `ConnectionList_avatar__COuHB`,
	"userInfoContainer": `ConnectionList_userInfoContainer__rc+CB`,
	"userName": `ConnectionList_userName__fjt1I`,
	"textConnectionDescription": `ConnectionList_textConnectionDescription__pyXq2`,
	"clickable": `ConnectionList_clickable__d6LzL`,
	"animated": `ConnectionList_animated__4ZsdO`,
	"slideUp": `ConnectionList_slideUp__nRwh1`,
	"dismissingOverlay": `ConnectionList_dismissingOverlay__KoEt6`,
	"show": `ConnectionList_show__Qo3rf`,
	"hide": `ConnectionList_hide__fTj9D`,
	"actionWrapper": `ConnectionList_actionWrapper__L1Wyt`,
	"loaderContainer": `ConnectionList_loaderContainer__exu-c`,
	"barWrapper": `ConnectionList_barWrapper__8DiQr`,
	"spinner": `ConnectionList_spinner__CwQDd`,
	"groupRoleLabel": `ConnectionList_groupRoleLabel__n-8VM`
};
export default ___CSS_LOADER_EXPORT___;
